import { useCallback } from "react";
import { useStore } from "react-redux";

import { ALL_ORDERS_ACTION_ENUM } from "../common/reducers/allOrders";
import { MY_ORDERS_ACTION_ENUM } from "../common/reducers/myOrders";
import OrderService from "../service/OrderService";

export const useOrderFetcher = () => {
  const { dispatch } = useStore();

  /**
   * Local user's orders
   */
  const fetchMyOrdersAndUpdateStore = useCallback(async () => {
    dispatch({
      type: MY_ORDERS_ACTION_ENUM.UPDATE_LOADING,
      payload: { loading: true },
    });

    const res = await OrderService.getMyOrders();

    dispatch({
      type: MY_ORDERS_ACTION_ENUM.UPDATE_ORDERS,
      payload: { orders: res.data.data || [] },
    });
  }, [dispatch]);

  /**
   * All customer's orders (for admins and designers)
   */
  const fetchAllPurchasedOrdersAndUpdateStore = useCallback(async () => {
    dispatch({
      type: ALL_ORDERS_ACTION_ENUM.UPDATE_LOADING,
      payload: { loading: true },
    });

    const res = await OrderService.getAllPurchasedOrders();

    dispatch({
      type: ALL_ORDERS_ACTION_ENUM.UPDATE_ALL_PURCHASED_ORDERS,
      payload: res.data.data || [],
    });
  }, [dispatch]);

  //Will fetch order detail with colors expanded and with decorations' assets' urls
  const fetchOrderDetail = useCallback(async (orderId: string) => {
    const res = await OrderService.getPurchasedOrder(orderId);

    return res.data.data;
  }, []);

  return {
    fetchMyOrdersAndUpdateStore,
    fetchAllPurchasedOrdersAndUpdateStore,
    fetchOrderDetail,
  };
};
